export default __webpack_public_path__ + "static/media/github.307bff39.svg";